import store from "@/store"

export default (to, from, next) => {
  if (!store.getters["identity/getJWT"]) {
    next({ name: "Home" })
    store.dispatch("ui/SET_NAV_ACTIVE_ELEMENT", "login")
  } else {
    next()
  }
}
